// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightTwoToneSvg from "@fishx/icons-svg/es/asn/CopyrightTwoTone";
import FishxIcon from '../components/FishxIcon';

var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightTwoToneSvg
  }));
};

CopyrightTwoTone.displayName = 'CopyrightTwoTone';
export default React.forwardRef(CopyrightTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CopyrightTwoTone.js
// module id = 2335
// module chunks = 0